<template>
	<search-list ref="sl" :where="where" :order="order" :attributes="[]" api-path="/mmpOffer/list" notSearchAll :searchKeys="searchKeys" :handleResponse="handleResponse">
		<div class="search-condition">
			<div class="row">
				<mm-lc title="Offer Month" class="gim-select">
					<singleMonthPicker v-model="where.offer_month" />
				</mm-lc>
				<mm-lc title="Adv" class="gim-select">
					<mm-adv-select no_paused v-model="where.adv_id" multiple />
				</mm-lc>
				<mm-lc title="Manual Status" class="gim-select">
					<mm-offer-status v-model="where.manual_status" multiple />
				</mm-lc>
				<mm-lc title="Platform" class="gim-select">
					<mm-offer-platform v-model="where.platform" multiple />
				</mm-lc>
				<mm-lc title="Country" class="gim-select">
					<mm-offer-geos v-model="where.geos" multiple />
				</mm-lc>
				<mm-lc title="Currency" class="gim-select">
					<mm-offer-currency v-model="where.currency" multiple />
				</mm-lc>
				<mm-lc title="Pricing Model" class="gim-select">
					<mm-offer-pricing-model v-model="where.pricing_model" multiple />
				</mm-lc>
				<mm-lc title="Group" class="gim-select">
					<mm-select multiple :options="groupOptions" return-array v-model="attributes"/>
				</mm-lc>
				<mm-lc title="Tracker" class="gim-select">
					<mm-dict-select v-model="where.tracker_id" dictType="tracker"></mm-dict-select>
				</mm-lc>
				<mm-lc title="Category" class="gim-select">
					<mm-offer-category v-model="where.category"/>
				</mm-lc>
				<mm-lc title="Manager" class="gim-select">
					<mm-users multiple v-model="where.offer_bd"/>
				</mm-lc>
			</div>
		</div>
		<div slot="customSearch">
			<mm-lc title="Af Prt">
				<mm-multi-input v-model.trim="where.af_prt" />
			</mm-lc>
		</div>

		<el-dropdown size="mini" trigger="click" slot="statusAction">
			<el-button size="small" type="primary" icon="el-icon-edit">
				Batch Op
			</el-button>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item @click.native="()=>showEditCamp=true">Edit Campaign</el-dropdown-item>
				<el-dropdown-item class="status-active" @click.native="batchOp(switchStatus,'active')">Switch to Active</el-dropdown-item>
				<el-dropdown-item class="status-paused" @click.native="batchOp(switchStatus,'paused')">Switch to Paused</el-dropdown-item>
				<el-dropdown-item class="status-pending" @click.native="batchOp(switchStatus,'pending')">Switch to Pending</el-dropdown-item>
				<el-dropdown-item class="status-pending" @click.native="openCopyToAnotherMonthDialog">Switch to Another Month</el-dropdown-item>
				<el-dropdown-item class="status-pending" @click.native="getJson">Get JSON Info</el-dropdown-item>
				<el-dropdown-item class="status-pending" @click.native="openCreateOfferDialog">Batch Create</el-dropdown-item>
				<el-dropdown-item @click.native="()=>showRemark=true">Remark</el-dropdown-item>
				<!-- <el-dropdown-item class="status-paused" @click.native="batchOp(deleteAll,'')">Switch to Delete</el-dropdown-item> -->
			</el-dropdown-menu>
		</el-dropdown>
		<el-button slot="actions" type="success" class="el-icon-document-add" @click="create" />

		<mm-table ref="table" slot="dataTable" slot-scope="res" :res="res" @selection-change="selectionChange"  @sort-change="sortChange">
			<template slot-scope="etc">
			<el-table-column type="selection" fixed="left"/>
			<el-table-column label="Offer Month" prop="offer_month" min-width="120" fixed="left"/>
			<el-table-column label="Offer Id" prop="offer_id" min-width="150" slot="default" :renderHeader="etc.renderHeaderCopy" fixed="left">
				<mm-get-detail slot-scope="sp" row_type="mmp_offer" :row_id="sp.row.offer_id+','+sp.row.offer_month" :row_name="sp.row.offer_id">
					<el-button type="text" icon="el-icon-edit-outline" class="copy-offer-id" @click="copyOfferId(sp.row.offer_id)"/>
				</mm-get-detail>
			</el-table-column>
			<el-table-column label="Offer Name" prop="offer_name" min-width="120" fixed="left" :renderHeader="etc.renderHeaderCopyNew('\r')"/>
			<el-table-column label="Af Prt" prop="af_prt" width="110" fixed="left"/>
			<el-table-column label="Payable Event" prop="payable_event" min-width="130" fixed="left"></el-table-column>
			<el-table-column label="Adv Offer Id" prop="adv_offer_id" width="110"/>
			<el-table-column label="Adv">
				<mm-get-detail slot-scope="sp" :row_name="sp.row.adv_name" :row_id="sp.row.adv_id" row_type="adv" />
			</el-table-column>
			<el-table-column label="Tracker" prop="tracker_id"></el-table-column>

			<el-table-column label="Regions" prop="geo" width="90">
				<div slot-scope="sp">
					<span v-if="sp.row.geo && sp.row.geo.length < 9">{{ sp.row.geo }}</span>
					<el-tooltip :content="sp.row.geo" v-else>
						<span>{{ sp.row.geo && sp.row.geo.substr(0, 8) }}...</span>
					</el-tooltip>
				</div>
			</el-table-column>
			<el-table-column label="Platform" prop="platform" />
			<el-table-column label="Package Name" prop="package_id" v-if="containGroup('package_id')" width="120" />
			<!-- <el-table-column label="PackageId" prop="package_id" /> -->
			<el-table-column label="Pricing Model" prop="pricing_model" width="100"></el-table-column>
			<el-table-column label="Pirce" prop="offer_price"></el-table-column>
			<el-table-column label="Time" min-width="150">
				<template slot-scope="sp">
					<el-row>{{timeFormat(sp.row.create_at)}}</el-row>
					<el-row>{{timeFormat(sp.row.update_at)}}</el-row>
				</template>
			</el-table-column>
			<el-table-column label="KPI" prop="kpi" v-if="containGroup('kpi')" width="120"/>
			<el-table-column label="Preview Link" prop="preview_url" v-if="containGroup('preview_url')" width="120" />
			<el-table-column label="Remark" prop="remark" width="120" >
				<template slot-scope="sp">
					<div v-if="!sp.row.remark || sp.row.remark.length <= 20">{{ sp.row.remark }}</div>
					<el-popover
						v-else
						placement="top-start"
						width="200"
						trigger="click"
					>
						<div v-html="sp.row.remark.replace(/\n/g, '<br/>')">
						</div>
						<el-button slot="reference" type="text">{{ sp.row.remark.substring(0, 20) + '...' }}</el-button>
					</el-popover>
				</template>
			</el-table-column>
			<el-table-column label="Manual Status" prop="manual_status" fixed="right" width="120">
				<span slot-scope="sp" :class="'status-'+sp.row.manual_status">{{sp.row.manual_status.toUpperCase()}}</span>
			</el-table-column>
			<el-table-column label="action" fixed="right">
				<template slot-scope="sp">
					<el-dropdown szie="small" trigger="click">
						<el-button type="primary" plain size="mini">Action</el-button>
						<el-dropdown-menu slot="dropdown" >
							<el-dropdown-item @click.native="edit(sp.row)">Edit</el-dropdown-item>
							<el-dropdown-item @click.native="copyToCreate(sp.row)">Copy to Create</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>
			</el-table-column>
			</template>
		</mm-table>
		<el-dialog :visible.sync="showEditCamp">
			<span slot="title">Edit Campaigns</span>
			<el-form ref="form" :model="camp" label-width="120px" class="edit-camp">
				<el-form-item label="Channel" prop="channel_ids" required>
					<mm-channel-select no_paused v-model='camp.channel_ids' multiple />
				</el-form-item>
				<div class="camp-item">
					<span>
						<el-form-item label="Pid" required prop="pid">
							<div class="percent-input">
								<el-input v-model.trim="camp.pid"></el-input>
							</div>
						</el-form-item>
						<el-form-item label="Cap">
							<div class="percent-input">
								<el-input v-model='camp.cap_info'/>
							</div>
						</el-form-item>
						<el-form-item label="Payout"  required prop="offer_price">
							<div class="percent-input">
								<el-input type="number" @mousewheel.native.prevent v-model="camp.offer_price"/>
							</div>
						</el-form-item>
					</span>
				</div>
				<el-form-item label="Events" prop="events">
				<el-button size="medium" type="success" @click="addEvent">ADD</el-button>
				<div v-for="(item, key) in camp.events" :key="key" style="padding-left: 30px;">
					<div>
					<span style="padding-right:20px;">Event {{ key+1 }}</span>
					<el-button size="medium" type="danger" @click="deleteEvent(key)">Delete Event {{ key+1 }}</el-button>
					</div>
					<el-form-item label="Event Name">
					<el-input v-model="item.event_name"></el-input>
					</el-form-item>
					<el-form-item label="Event Value" :prop="`event_value`+key" :rules="eventValueRules" >
					<el-input v-model="item.event_value"></el-input>
					</el-form-item>
					<el-form-item label="Payout">
					<el-input type="number" @mousewheel.native.prevent v-model="item.payout"/>
					</el-form-item>
				</div>
				</el-form-item>
				<el-form-item label="Tracking Link" style="width:80%;" required prop="tracking_link">
					<el-input type="textarea" rows="6" v-model='camp.tracking_link' />
				</el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click="editCamp">Save</el-button>

				</el-form-item>
			</el-form>

		</el-dialog>
		<el-dialog :visible.sync="showRemark">
			<span slot="title">Remark</span>
			<el-form label-width="200px" class="edit-timezone" ref="remarkForm"  :model="remarkBody">
				<el-form-item label="Status" prop="status" required>
					<mm-offer-status v-model="remarkBody.status" />
				</el-form-item>
				<el-form-item label="Remark" prop="remark" required>
					<el-input v-model="remarkBody.remark" type="textarea" :rows="5" />
				</el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click="remark">Save</el-button>

				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog :visible.sync="copyToOtherMonthVisible">
			<span slot="title">Copy To Another Month</span>
			<el-form label-width="200px" class="edit-timezone" ref="copyForm"  :model="copyBody">
				<el-form-item label="Another Month" prop="month" required>
					<el-date-picker v-model="copyBody.month" type="month" value-format="yyyy-MM"></el-date-picker>
				</el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click="copySubmit">Save</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog :visible.sync="createOfferDialogVisible">
			<span slot="title">Create Offer</span>
			<el-form label-width="200px" class="edit-timezone" ref="createForm"  :model="createBody">
				<el-form-item label="Month" prop="offer_month" required>
					<el-date-picker
						v-model="createBody.offer_month"
						type="month"
						value-format="yyyy-MM"
						placeholder="Select"
						style="width:100%;"
					/>
				</el-form-item>
				<el-form-item label="Adv Id" prop="adv_id" required>
					<mm-adv-select style="width:100%;" v-model="createBody.adv_id" />
				</el-form-item>
				<el-form-item label="Offer Bd" prop="offer_bd" required>
					<mm-users style="width:100%;" v-model="createBody.offer_bd"/>
				</el-form-item>
				<el-form-item label="Offer JSON" prop="offer_json" required>
					<el-input style="width:100%;" v-model="createBody.offer_json" type="textarea" :rows="5" />
				</el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click="createOfferSubmit">Save</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</search-list>
</template>

<script>
import singleMonthPicker from '../components/common/singleMonthPicker.vue';
export default {
	components: {
		singleMonthPicker,
	},
	data() {
		const groupOptions=[
			{label:'KPI',value:'kpi'},
			{label:'Preview Link',value:'preview_url'},
			{label:'Package Name',value:'package_id'},
		]
		const searchKeys = {
			offer_id: { label: "Offer Id" },
			adv_offer_id: { label: "Adv Offer Id" },
			offer_name: { label: "Offer Name", fuzzy: true },
			package_id: { label: "Package Id", fuzzy: true },
			app_name: { label: "App Name" },
		};
		const offer_month = this.$utils.date_format((new Date()),'YYYY-MM');
    const user_info = this.$utils.getCookies(['group_name','is_super','user_name']);
    const is_super = (user_info.group_name === 'admin'&&user_info.is_super=='1');
		return {
			where: {
				offer_month,
				manual_status: ['active'],
			},
			order: [['update_at',-1]],
			attributes:[],
			groupOptions,
			camp: {
				events: [],
			},
			searchKeys,
			selected: [],
			showEditCamp: false,
			campRules: {
				channel_ids: [{ required: true, message: 'channel is required' }],
			},
			eventValueRules: [{
				required: true,
				validator: this.eventValueValidator
			}],
			showRemark: false,
			remarkBody: {},
			copyToOtherMonthVisible: false,
			copyBody: {
				month: '',
			},
			createBody: {
				offer_month: offer_month,
				adv_id: '',
				offer_bd: user_info.user_name,
			},
			is_super,
			createOfferDialogVisible: false,
		};
	},
	methods: {
		handleResponse(body) {
			body.rows && body.rows.forEach((row) => {
				row.payable_event = row.events ? row.events.map((e) => e.event_name).join(', ') : '';
			})
		},
		eventValueValidator(rule, value, callback) {
			if (!this.camp.events || this.camp.events.length == 0) {
				callback();
			} else {
				let isEmpty = false;
				this.camp.events.forEach((row) => {
					if (!row.event_value) {
						isEmpty = true;
					}
				})
				if (isEmpty) {
					callback(new Error('event_value is required'));
				} else {
					callback();
				}
			}
		},
		copyOfferId(offer_id) {
			this.$copyText(`${offer_id}`).then((res) => {
				this.$message({
					type:'success',
					message:'Copied ' + offer_id,
				})
			}).catch((e) => {
				console.log('e', e);
			});
		},
		containGroup(key){
			if(this.attributes && this.attributes.indexOf(key)>-1){
				return true;
			}
			return false;
		},
		timeFormat(date) {
			date = new Date(date);
			return this.$utils.date_format(date, "YYYY-MM-DD hh:mm:ss");
		},
		selectionChange(v) {
			this.selected = v.map((v) => { return { offer_id: v["offer_id"], offer_month: v['offer_month'], _id: v['_id'] } });
		},
		async batchOp(fn, value) {
			if (this.selected.length === 0) {
				this.$message({ message: "no selection!", type: "warning" });
			} else {
				await fn(value);
				await this.$refs.sl.refresh();
				this.$refs.table.$el.$refs.mm_table.clearSelection();
				this.selected = [];
			}
		},
		async switchStatus(status) {
			await this.$post("/mmpOffer/switchStatus", {
				offer_info: this.selected,
				status
			});
		},
		async switchToCurrentMonth() {
			const res = await this.$post("/mmpOffer/switchToCurrentMonth", {
				offer_info: this.selected,
				month: this.copyBody.month,
			});
			// res: {total: number, success: number, fail: number, exist: number}
			this.$message({
				type: 'success',
				message: `Total: ${res.total}, Success: ${res.success}, Fail: ${res.fail}, Exist: ${res.exist}`,
			})
			this.copyToOtherMonthVisible = false;
		},
		openCopyToAnotherMonthDialog() {
			if (this.selected.length === 0) {
				this.$message({ message: "no selection!", type: "warning" });
			} else {
				this.copyToOtherMonthVisible = true;
			}
		},
		async copySubmit() {
			await this.$validate(this.$refs.copyForm);
			await this.switchToCurrentMonth();
		},
		async deleteAll() {
			await this.$confirm('Delete All?', 'Tips', {
				confirmButtonText: 'Yes',
				cancelButtonText: 'No',
				type: 'warning'
			}).then(async () => {
				await this.$post("/mmpOffer/delete", {
					offer_info: this.selected,
				});
			})
		},
		create() {
			window.open("/mmpOfferCreate");
		},
		edit(row) {
			window.open(`/mmpOfferEdit?id=${row.offer_id}&month=${row.offer_month}`);
		},
		copyToCreate(row) {
			window.open(`/mmpOfferCreate?copy_id=${row.offer_id}&month=${row.offer_month}`);
		},
		async editCamp() {
			await this.$validate(this.$refs.form);
			await this.$post("/mmpOffer/editCamp", {
				offer_info: this.selected,
				camp: this.camp
			});
			this.showEditCamp = false;
		},
		async sortChange(column){
			const order = this.order;
			if(column.order == 'ascending'){
				order[0] = [column.prop, 1];
			}else if(column.order == 'descending'){
				order[0] = [column.prop, -1];
			}else {
				order[0] = ['update_at',-1];
			}
			await this.$refs.sl.refresh();
			this.order[0] = ['update_at',-1];
		},

		addEvent() {
			this.camp.events.push({
				event_name: '',
				event_value: '',
				payout: 0,
			})
		},
		deleteEvent(index) {
			this.camp.events.splice(index, 1);
		},
		async remark() {
			if (this.selected.length === 0) {
				this.$message({ message: "no selection!", type: "warning" });
			} else {
				await this.$validate(this.$refs.remarkForm);
				await this.$post('/mmpOffer/switchStatus', {
					...this.remarkBody,
					offer_info: this.selected,
				});
				this.showRemark = false;
				await this.$refs.sl.refresh();
			}
		},
		async getJson() {
			if (this.selected.length === 0) {
				this.$message({ message: "no selection!", type: "warning" });
			} else {
				const offerFixList = await this.$post('/dict/selectList',{
          type: 'mmpOfferJsonFix',
        })
				const item = offerFixList.find((o) => o.name == 'offer_name');
				const prefix = item? item.label : window.location.hostname.charAt(0).toLocaleUpperCase();
				const selected = JSON.parse(JSON.stringify(this.$refs.table.$refs.mm_table.selection));
				selected.forEach((item) => {
					// let prefix = '';
					// const adv = this.$cache['adv_list'].find(row => row.value == item.adv_id);
					// if (adv && adv.account_level == 't') {
					// 	const match = adv.name.match(/\*?(\([a-zA-Z0-9]\))/);
					// 	if (match) {
					// 		prefix = match[1];
					// 	}
					// }
					// console.log(adv, prefix)
					delete item._id;
					delete item.__v;
					delete item.create_at;
					delete item.update_at;
					delete item.adv_id;
					delete item.adv_name;
					delete item.offer_bd;
					delete item.geos;
					item.offer_name = prefix + '_' + item.offer_name;
				})
				this.$copyText(JSON.stringify(selected)).then((res) => {
					this.$message({
						type:'success',
						message:'Copied JSON',
					})
				}).catch((e) => {
					console.log('e', e);
				});
			}
		},
		openCreateOfferDialog() {
			this.createOfferDialogVisible = true;
		},
		async createOfferSubmit() {
			await this.$validate(this.$refs.createForm);
			let offers = null;
			try {
				offers = JSON.parse(this.createBody.offer_json);
				if (!Array.isArray(offers)) {
					this.$message({ message: "Offer JSON should be an array", type: "error" });
					return;
				}
				offers.forEach((offer) => {
					if (!offer.offer_id || !offer.offer_name) {
						this.$message({ message: "offer_id and offer_name are required for each offer", type: "error" });
						throw new Error("offer_id and offer_name are required for each offer");
					}
				})
			} catch(e) {
				this.$message({ message: "Invalid JSON", type: "error" });
				return;
			}
			const body = {
				offer_month: this.createBody.offer_month,
				adv_id: this.createBody.adv_id,
				offer_bd: this.createBody.offer_bd,
				offers: JSON.parse(this.createBody.offer_json),
			}
			await this.$post('/mmpOffer/createMany', body);
			this.createOfferDialogVisible = false;
			await this.$refs.sl.refresh();
		}
	}
};
</script>

<style scoped>
.edit-camp {
	width: 100%;
	height: 500px;
	overflow-y: auto;
}
.camp-item {
	display:flex;
}
.percent-input {
	width: 130px;
}
.el-form-item {
	width: 500px;
}
.search-condition {
	display: flex;
	flex-direction: column;
}
.row {
	display: flex;
	flex-direction: row;
	margin-bottom: 5px;
}
.copy-offer-id{
	display: inline;
	margin-left: 5px;
}
.manual-offer{
	color:brown;

}
.switch-actions {
	padding-right: 10px;
}
.switch-select {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
	padding-left: 20px;
	font-size: 13px;
}
</style>


